/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* CreateReportResponse carries the ids of the resources created by CreateReport. report_id is always present. run_id is present only when should_run_now was true on the request. schedule_ids is non-empty only when the request included one or more schedules.
*/
export class V1CreateReportResponse {
    /**
    * The id of the newly created report. Always present.
    */
    'reportId'?: string;
    /**
    * The id of the first run. Present only when should_run_now was true on the request; empty otherwise.
    */
    'runId'?: string;
    /**
    * One id per schedule submitted in the request, in the same order. Empty when the request included no schedules.
    */
    'scheduleIds'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "reportId",
            "baseName": "report_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "runId",
            "baseName": "run_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "scheduleIds",
            "baseName": "schedule_ids",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1CreateReportResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

